import React from "react";
import {Collapse, ListItem} from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import List from "@mui/material/List";
import {useNavigate} from "react-router-dom";

const SubMenuMobile = ({title, subMenu}) => {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        setOpen(!open);
    };

    const createNavigationHandler = (navigationLink) => () => {
        navigate(navigationLink);
    }

    return(
        <ListItem style={{display:"flex", flexDirection: "column", alignItems:"start"}}>
            <ListItemButton style={{color:"black"}} onClick={handleClick}>
                <ListItemText primary={title} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{display:"flex", flexDirection: "column"}}>
                    {subMenu.map((item, index) => (
                        <ListItemButton key={index} onClick={createNavigationHandler(item.link)} sx={{ pl: 4 }}>
                            <ListItemText style={{color:"black"}} primary={item.title} />
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </ListItem>
    )
}

export default SubMenuMobile
